<template>
  <div class="car">
    <div
      class="car-item"
      v-for="(item, index) in carPrizeList"
      :key="index"
      v-auth:click="{ method: select, params: item }"
    >
      <div class="car-item__img">
        <img :src="item.baiPic" alt="" />
      </div>
      <div class="car-item__name">{{ item.name }}</div>
      <div class="car-item__price">{{ hiddenPrice(item.price) }}万起</div>
      <div class="car-item__btn" v-if="askedPriceIds.indexOf(item.id) < 0">获取底价</div>
      <div class="car-item__btn active" v-else>已经询价</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    carPrizeList: {
      type: Array,
      default() {
        return [];
      },
    },
    askedPriceIds: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    hiddenPrice() {
      return (value) => {
        const str = value.split('-')[0];
        const index = str.indexOf('.') + 1;
        const str1 = str.substring(0, index) + '**';
        return str1;
      };
    },
  },
  methods: {
    select(item) {
      if (this.askedPriceIds.indexOf(item.id) > -1) return;
      this.$emit('select', item);
    },
  },
};
</script>
<style lang="scss" scoped>
.car {
  display: flex;
  flex-wrap: wrap;
  margin: 0 30px;
  &-item {
    width: 203px;
    margin-left: 20px;
    margin-bottom: 20px;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 20px;
    &__img {
      height: 145px;
      align-items: center;
      display: flex;
      overflow: hidden;
      justify-content: center;
      img {
        width: 80%;
      }
    }
    &__name {
      font-size: 30px;
      font-weight: bold;
      text-align: center;
      margin: 10px auto;
    }
    &__price {
      font-size: 24px;
      color: #ff3e00;
      text-align: center;
    }
    &__btn {
      width: 158px;
      height: 44px;
      line-height: 44px;
      border-radius: 22px;
      text-align: center;
      color: #ffffff;
      margin: 20px auto;
      background: linear-gradient(to right, #ffda79, #ff3e45);
      &.active {
        background: #999999;
        color: #ffffff;
      }
    }
  }
}
</style>
